import React from 'react';
export var IconPaymentVisa = function IconPaymentVisa(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? '32' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '50' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    "data-testid": "icon-payment-visa",
    height: height,
    viewBox: "0 0 50 32",
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "Visa logo"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    height: "32",
    rx: "6",
    width: "50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.351 10.196-5.636 12.608h-3.687l-2.784-10.06c-.139-.588-.348-.85-.835-1.11-.835-.393-2.226-.85-3.409-1.046l.07-.392h5.914c.765 0 1.461.457 1.6 1.307l1.461 7.316 3.618-8.558h3.688v-.065zm14.403 8.492c0-3.331-4.87-3.527-4.87-4.964 0-.458.487-.915 1.46-1.046.488-.065 1.88-.13 3.41.588l.626-2.678c-.835-.261-1.878-.588-3.27-.588-3.41 0-5.845 1.698-5.845 4.18 0 1.83 1.74 2.81 3.062 3.398 1.322.588 1.809.98 1.809 1.568 0 .849-1.044 1.24-2.087 1.24-1.74 0-2.784-.456-3.549-.783l-.626 2.744c.835.326 2.296.653 3.827.653 3.618 0 5.983-1.698 6.053-4.312m9.045 4.116H46l-2.783-12.608h-2.992c-.696 0-1.253.392-1.461.915l-5.219 11.693h3.618l.696-1.894h4.453l.487 1.894zm-3.896-4.442 1.809-4.704 1.044 4.704h-2.853zM24.29 10.196 21.44 22.804h-3.48l2.853-12.608h3.48z",
    fill: "#1A1F71",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "31",
    rx: "6",
    stroke: "#AEBCC6",
    width: "49",
    x: ".5",
    y: ".5"
  })));
};